import { Modal } from "react-bootstrap";
import "./deleteConfirmationModal.css";
import { BsExclamationTriangle } from "react-icons/bs";

interface DeleteConfirmationModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  title: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  show,
  onHide,
  onConfirm,
  title,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="delete-confirmation-modal"
    >
      <Modal.Body className="p-0">
        <div className="modal-grid">
          <div className="modal-left">
            <div className="logo-section">
              <div className="app-logo">QRSharp</div>
            </div>
            <h2>Delete QR Code</h2>
            <p className="description">
              Are you sure you want to delete "{title}"? This action cannot be
              undone.
            </p>
            <div className="button-group">
              <button className="cancel-btn" onClick={onHide}>
                Cancel
              </button>
              <button className="delete-btn" onClick={onConfirm}>
                Delete
              </button>
            </div>
          </div>
          <div className="modal-right">
            <div className="features-section">
              <h6>Warning</h6>
              <ul className="features-list">
                <li>
                  <BsExclamationTriangle /> This action is permanent
                </li>
                <li>
                  <BsExclamationTriangle /> The QR code will be removed from
                  your account
                </li>
                <li>
                  <BsExclamationTriangle /> All associated data will be deleted
                </li>
                <li>
                  <BsExclamationTriangle /> This cannot be recovered
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteConfirmationModal;
